export var MuiToolbar = {
    styleOverrides: {
        regular: {
            '@media (min-width: 600px)': {
                minHeight: 44,
            },
        },
        dense: {
            '@media (min-width: 600px)': {
                minHeight: 28,
            },
        },
    },
};
